import React, { useState } from "react"
import { eventMovedBy } from "./plannerCalendar"
import { competitionLabel, daysLabel, plural, weekdayTimeLabel } from "./plannerLabels"
import { NewDatesWarnings } from "./MoveDialog"
import PlannerDialog from "./PlannerDialog"

// The event date history's rule for a note (Phase A4): at most 500 characters.
const MAX_NOTE = 500

// "Move published event #39144?" (ticket 14, Phase E3): what a move by whole weeks changes before it is sent — the old and new dates, when
// registrations will open, the competition starts that follow, the warnings its unpublished neighbours would get there (`newDates`, from
// the server's engine, never blocking; none for a cancelled event, which takes part in none: `neighbours` false), a line when its Logistics
// sheet already shipped, and an optional note the event's date history keeps. Nothing is sent to the organizer. `onConfirm(note)` starts the
// move, which still waits 7 s with Undo (E3-Q1). The page gives the event as the calendar reads it now.
export default function EventMoveDialog({ item, weeks, timeZone, neighbours, newDates, onClose, onConfirm }) {
  const [note, setNote] = useState("")
  const zone = item.timezone || timeZone
  const to = eventMovedBy(item, weeks, timeZone)
  const starts = to.competitions.filter(competition => competition.startDate)
  return <PlannerDialog title={`Move published event #${item.eventId}?`} wide
    sub={`${item.label} · ${item.name || "No name"} · ${plural(Math.abs(weeks), "week")} ${weeks > 0 ? "later" : "earlier"}`}
    dirty={Boolean(note.trim())} onClose={onClose}
    actions={<button type="button" className="btn btn-primary" onClick={() => onConfirm(note.trim())}>Move event</button>}>
    <dl className="ep-facts">
      <dt>Dates</dt><dd>{`${daysLabel(item.days)} → ${daysLabel(to.days)}`}</dd>
      {to.registrationsOpenAt && <><dt>Registrations open</dt>
        <dd>{`${weekdayTimeLabel(to.registrationsOpenAt, zone)} (now ${weekdayTimeLabel(item.registrationsOpenAt, zone)})`}</dd></>}
    </dl>
    {starts.length > 0 && <section className="ep-stack" aria-label="Competition starts">
      <b>{`${plural(starts.length, "competition start")} ${starts.length === 1 ? "follows" : "follow"}`}</b>
      <ul className="mb-0">{starts.map(competition => <li key={competition.id}>
        {`${competitionLabel(competition)}: ${weekdayTimeLabel(competition.startDate, zone)}`}</li>)}</ul>
    </section>}
    {neighbours && <NewDatesWarnings answer={newDates} timeZone={timeZone} neighbours />}
    {item.logisticsShipped && <p className="ep-banner ep-banner-warn mb-0">The Logistics sheet is already shipped: the issued AWBs stay as they are.</p>}
    <div className="ep-field">
      <label htmlFor="ep-event-move-note">Note on the date change (optional)</label>
      <textarea id="ep-event-move-note" className="form-control" rows={2} maxLength={MAX_NOTE} value={note} onChange={event => setNote(event.target.value)} />
    </div>
    <p className="ep-meta mb-0">The organizer is not informed: tell them yourself.</p>
  </PlannerDialog>
}
